var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEscalated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 27.666,
    viewBox: "0 0 32 27.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-rotate-111880",
    transform: "translate(-158.582 -63.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11807",
    "data-name": "Path 11807",
    d: "M178.5,75.858a1.024,1.024,0,0,1,.289.742v6.723a1.032,1.032,0,0,1-2.062,0V79.034c-3.96,4-8,8-12,12a.851.851,0,0,1-.577.289,1.061,1.061,0,0,1-.866-.289,16.067,16.067,0,0,1,19.384-25.282c9.156,5.279,10.517,17.817,3.341,25.282-.907.949-2.392-.495-1.444-1.444a14.007,14.007,0,1,0-20.5-.784l11.177-11.177h-4.289a1.032,1.032,0,0,1,0-2.062h6.846a1,1,0,0,1,.7.289Z",
    transform: "translate(0 0)",
    fill: "#0082a0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalated);
export default __webpack_public_path__ + "static/media/escalated.57d179568e758a6da39461afc6591116.svg";
export { ForwardRef as ReactComponent };